export const COMPANY = {
  NAME: "Repackify",
  LEGAL_NAME: "Repackify Inc.",
  DOMAIN: "repackify.com",
  URL: "https://www.repackify.com",

  PHONE: "888-413-7506",
  PHONE_FORMATTED: "(888) 413-7506",

  PHONE_TEL: "+18884137506",

  DEFAULT_COUNTRY: "USA",

  TIME_ZONE: "America/Chicago",

  ADDRESS: {
    line1: "PO Box 300788",
    city: "Austin",
    state: "TX",
    postalCode: "78703",
    country: "US",
  },

  EMAILS: {
    SUPPORT: "support@repackify.com",
    SALES: "sales@repackify.com",
    INFO: "info@repackify.com",
    ACCOUNTING: "accounting@repackify.com",
    AP: "ap@repackify.com",
  },

  SOCIAL: {
    LINKEDIN: "https://www.linkedin.com/company/repackify",
    TWITTER: "https://twitter.com/repackify",
    FACEBOOK: "https://www.facebook.com/repackify",
  },
} as const;

export type CompanyEmailKey = keyof typeof COMPANY.EMAILS;
